import { buildAstState } from '.';
import { canUse } from '../can-use.utils';
import generateID from '../generate-id';

export const getAstColorTable = (theme: StoreThemeItem) => {
  const colorGroupTable: string[] = [];
  theme.colorGroupTable.forEach((item, index) => {
    // 如果是单息屏，则仅获取第一个配色
    if (theme.type == 'AOD' && theme.isSingleAOD && index > 0) return;
    // 如果不支持多配色
    if (
      buildAstState.data.colorMode == 'colorGroup' &&
      !canUse('multi-color-group').valid &&
      index > 0
    )
      return;

    const color = item.color;
    if (color && !colorGroupTable.includes(color)) colorGroupTable.push(color);
  });
  return colorGroupTable;
};

/**
 * 获取当前表盘root ast数据，返回的结构如下(xml形式)
 * ```
 * <Watchface name="name" width="466" height="466" SKU="false"  colorGroupTable="#ffffff">
    <Resources/>
   </Watchface>
 * ```
 * @returns
 */
export default () => {
  const { description, colorMode } = buildAstState.data;
  if (!description || !colorMode) return;

  const widthAndHeight = description.size?.split('x');

  const rootAst: Ast = {
    tag: 'Watchface',
    attrsMap: {
      name: description.name,
      width: widthAndHeight?.[0],
      height: widthAndHeight?.[1],
      id: description.pkgName ?? generateID(),
      SKU: 'false',
      _deviceType: description.deviceType ?? '',
      compressMethod: 'None',

      // https://xiaomi.f.mioffice.cn/wiki/NMf7wKSMsiIMIHk8D1zkgO9t4Sa
      advanced: description.watchOS == 'android' ? 'true' : 'false',
      interactive: 'false'
    },
    children: [{ tag: 'Resources', attrsMap: {}, children: [] }]
  };
  // 表盘压缩
  if (description.imageCompression) {
    if (description.deviceType == 'L67') {
      rootAst.attrsMap.compressMethod = 'RLE';
    } else {
      rootAst.attrsMap.compressMethod = 'RLEReversed';
    }
  }

  return rootAst;
};
